import type { Clinic } from "@louise/clinics/clinics.types";

export function truncateAtComma(text: string): string {
  const commaIndex = text.indexOf(",");
  return commaIndex > 0 ? text.substring(0, commaIndex) : text;
}

export function getClinicBadges(clinic: Clinic): string[] {
  const badges: string[] = [];

  if (clinic.isFirstConsultationFree) {
    badges.push("☂️ Free first consult");
  }

  if (
    clinic.insuranceAccepted ||
    (clinic.insurances && clinic.insurances.length > 0)
  ) {
    badges.push("☂️ Takes insurance");
  }

  if (clinic.treatments?.includes("Donor programs")) {
    badges.push("Donor program");
  }

  if (clinic.isRecordComplete) {
    badges.push("✓ Record Complete");
  }

  return badges;
}

/**
 * Get image feature badges for clinic card display
 * These are shown as overlays on clinic images
 */
export function getClinicImageFeatures(clinic: Clinic): string[] {
  const features: string[] = [];

  if (clinic.isFirstConsultationFree === true) {
    features.push("☂️ Free first consult");
  }

  if (
    clinic.insuranceAccepted === true ||
    (clinic.insurances && clinic.insurances.length > 0)
  ) {
    features.push("☂️ Takes insurance");
  }

  if (clinic.isRecordComplete) {
    features.push("✓ Record Complete");
  }

  return features;
}

